var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.226 0 127 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.38174e-06 5.56654e-06L17.4554 53.9129L8.58972e-07 51.2615L-1.38174e-06 5.56654e-06Z",
    fill: "#00923A",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4554 53.9129L2.42361e-06 87.0561L8.58972e-07 51.2615L17.4554 53.9129Z",
    fill: "#3BA934",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4554 53.9129L46.6214 91.0333L2.42361e-06 87.0561L17.4554 53.9129Z",
    fill: "#94C01F",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6214 91.0333L4.30696e-06 130.142L2.42361e-06 87.0561L46.6214 91.0333Z",
    fill: "#FFD400",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6214 91.0333L41.5395 130.142L4.30696e-06 130.142L46.6214 91.0333Z",
    fill: "#EB6609",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5395 130.142L73.3569 182.73L4.30696e-06 130.142L41.5395 130.142Z",
    fill: "#E4007D",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3569 182.73L40.8766 206.151L4.30696e-06 130.142L73.3569 182.73Z",
    fill: "#BE1722",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8766 206.151L7.62939e-06 206.151L4.30696e-06 130.142L40.8766 206.151Z",
    fill: "#312783",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3569 182.73L68.7169 206.151L40.8766 206.151L73.3569 182.73Z",
    fill: "#D84D1F",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7169 206.151L73.3569 182.73L127.348 206.151L68.7169 206.151Z",
    fill: "#F39200",
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.f56cca3899fc02318d55e9ece8abc395.svg";
export { ForwardRef as ReactComponent };